<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Comparables Filter</h3>
    </div>
  </div>

  <form class="form">
    <div class="card-body">
      <mat-dialog-content>
        <div class="filter-loading" *ngIf="loading$|async">
          <mat-spinner diameter="32"></mat-spinner>
          <span>Loading filter values…</span>
        </div>

        <cdk-accordion class="filter-accordion">
          <cdk-accordion-item
            *ngFor="let column of (columns$|async); trackBy: trackBy"
            #accordionItem="cdkAccordionItem"
            class="filter-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-' + column.key"
            [attr.aria-expanded]="accordionItem.expanded"
            [attr.aria-controls]="'accordion-body-' + column.key"
            (expandedChange)="onExpandedChange(column.key, $event)"
          >
            <div class="filter-accordion-item-header" (click)="accordionItem.toggle()">
              {{ column.label }}
            </div>
            <!--
              Only the open column is in the DOM. Rendering every column's values up front
              is what made the dialog slow to open on a tenant with many comparables.
            -->
            <div
              *ngIf="accordionItem.expanded"
              class="filter-accordion-item-body"
              role="region"
              [attr.id]="'accordion-body-' + column.key"
              [attr.aria-labelledBy]="'accordion-header-' + column.key"
            >
              <!-- Value search — applies to every column. -->
              <input #searchEl type="text" class="form-control form-control-sm filter-search"
                placeholder="Search"
                [value]="column.search"
                (input)="onChangeSearch(column.key, searchEl.value)" />

              <!-- Numeric columns (e.g. BUA): From/To range. -->
              <ng-container *ngIf="column.type == 'number'">
                <div class="range-row">
                  <span class="range-label">From</span>
                  <input #minEl type="number" class="form-control form-control-sm"
                    placeholder="Low"
                    [value]="column.range.min"
                    (input)="onChangeRange(column.key, 'min', minEl.value)" />
                  <span class="range-label">to</span>
                  <input #maxEl type="number" class="form-control form-control-sm"
                    placeholder="High"
                    [value]="column.range.max"
                    (input)="onChangeRange(column.key, 'max', maxEl.value)" />
                </div>
              </ng-container>

              <!-- Date columns: narrow to a month and/or year. -->
              <ng-container *ngIf="column.type == 'date'">
                <div class="range-row">
                  <span class="range-label">Month</span>
                  <input #monthEl type="number" min="1" max="12" class="form-control form-control-sm"
                    placeholder="MM"
                    [value]="column.month"
                    (input)="onChangeMonth(column.key, monthEl.value)" />
                  <span class="range-label">Year</span>
                  <input #yearEl type="number" class="form-control form-control-sm"
                    placeholder="YYYY"
                    [value]="column.year"
                    (input)="onChangeYear(column.key, yearEl.value)" />
                </div>
              </ng-container>

              <!--
                Long value lists scroll virtually — a column can run to thousands of
                entries, and only the dozen on screen are worth a checkbox.
              -->
              <cdk-virtual-scroll-viewport *ngIf="column.values.length > virtualScrollFrom"
                class="checkbox-list" [itemSize]="itemSize"
                [style.height.px]="listHeight(column.values.length)">
                <mat-checkbox *cdkVirtualFor="let item of column.values; trackBy: trackByIndex"
                  class="checkbox-item"
                  [checked]="item.checked"
                  (change)="onChangeValue(column.key, item.value, $event)"
                >
                  <ng-container *ngTemplateOutlet="valueLabel; context: { $implicit: item, column: column }"></ng-container>
                </mat-checkbox>
              </cdk-virtual-scroll-viewport>

              <div class="checkbox-list" *ngIf="column.values.length <= virtualScrollFrom">
                <mat-checkbox *ngFor="let item of column.values; trackBy: trackByIndex"
                  class="checkbox-item"
                  [checked]="item.checked"
                  (change)="onChangeValue(column.key, item.value, $event)"
                >
                  <ng-container *ngTemplateOutlet="valueLabel; context: { $implicit: item, column: column }"></ng-container>
                </mat-checkbox>
              </div>

              <!-- A capped list must say it is capped; a silent prefix reads as the whole set. -->
              <div class="filter-note" *ngIf="column.truncated">
                Too many values to list them all.
                <ng-container *ngIf="column.type == 'number'">Use From/To above, or</ng-container>
                search for the one you want.
              </div>
            </div>
          </cdk-accordion-item>
        </cdk-accordion>
      </mat-dialog-content>
    </div>
    <div class="card-footer p-0 b-0">
      <div class="form-actions form-actions-solid">
        <div class="row text-right">
          <div class="col-lg-12">
            <button type="button" mat-raised-button cdkFocusInitial (click)="onClose()">
              Close
            </button>&nbsp;
            <button type="button" class="btn btn-success" mat-raised-button color="submit"
              [disabled]="loading$|async" (click)="onSubmit()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #valueLabel let-item let-column="column">
  <ng-container *ngIf="item.value == 'Select All' || item.value == 'N/A'">
    {{ item.value }}
  </ng-container>
  <ng-container *ngIf="item.value != 'Select All' && item.value != 'N/A'">
    <ng-container [ngSwitch]="column.type">
      <ng-container *ngSwitchCase="'date'">{{ item.value|date:'dd MMM yyyy' }}</ng-container>
      <ng-container *ngSwitchCase="'number'">{{ item.value|mask:'separator.2':{thousandSeparator:','} }}</ng-container>
      <ng-container *ngSwitchDefault>{{ item.value }}</ng-container>
    </ng-container>
  </ng-container>
</ng-template>
